<template>
    <div>
        
    </div>
</template>

<script>
export default {
    mounted() {
        // Get the last parameter from the current URL
        const lastParam = this.getLastParamFromURL();
        // Call the API to get the store_hash_id
        this.getStoreHashId(lastParam)
            .then((storeHashId) => {
                // Perform the redirect using the store_hash_id
                this.redirectToStore(storeHashId);
            })
            .catch((error) => {
                console.error('Error:', error);
                // Handle the error or show an error message
            });
    },
    methods: {
        getLastParamFromURL() {
            // Get the current URL
            const currentURL = window.location.href;

            // Split the URL by '/'
            const urlParts = currentURL.split('/');

            // Get the last parameter from the URL
            const lastParam = urlParts[urlParts.length - 1];

            return lastParam;
        },
        getStoreHashId(lastParam) {
            // Call your API to get the store_hash_id based on the lastParam
            // Replace this with your actual API call
            return fetch(`${process.env.VUE_APP_API_DOMAIN}/v2/get_hash_id/${lastParam}`)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then((data) => {
                    return data.data.store_hash_id;
                })
                .catch((error) => {
                    console.error('There has been a problem with your fetch operation:', error);
                });
        },
        redirectToStore(storeHashId) {
            // Perform the redirect to the store using the storeHashId
            // Replace this with your actual redirect logic
            window.location.href = `${process.env.VUE_APP_V2_DOMAIN}/${storeHashId}/shop`;
        },
    },
};
</script>

<style>
/* Your component styles here */
</style>
